module.exports = __webpack_public_path__ + "static/media/illustration-element-04.c90ba3cb.svg";